import { CountriesService } from '../../../../services/countries.service';
import { Component, Input, OnChanges } from '@angular/core';
import { SalutationsService } from '../../../../services/salutations.service';
import { environment } from 'environments/environment';
import { find } from 'lodash';

@Component({
  selector: 'edit-shipping-address',
  styleUrls: [
    '../../../wizard/wizard.component.scss',
    '../step2.component.scss',
  ],
  templateUrl: './editAddress.component.html',
})
export class EditShippingAddressComponent implements OnChanges {
  @Input() address;
  @Input() step;
  @Input() totalSteps;
  @Input() save;
  @Input() prev;

  salutations = this.salutationsService.get();
  countries = this.countriesService.countries;
  showPrivacyModal;
  privacyPolicyLink = environment.privacyPolicyLink;
  states;
  disabled = true;

  constructor(
    private salutationsService: SalutationsService,
    private countriesService: CountriesService
  ) {
    this.getStates();
  }

  ngOnChanges() {
    console.log(Object.keys(this.address).length);
    this.address.country_code =
      this.address.country_code || this.countries[0].code;
    this.address.salutation =
      this.address.salutation || this.salutations[0].key;
    this.getStates();
    if ((Object.keys(this.address).length) >= 9) {
      this.disabled = false;
    }
  }

  onNumberChange(data) {
    if (data.target) {
      return;
    }
    this.address.phone_number = data;
  }

  displaySelectedCountry(country) {
    return country.name;
  }

  onCountryChanged(key) {
    this.address.country_code = key;
    this.address.state = undefined;
  }

  getStates() {
    if (!this.address || !this.address.country_code) {
      return false;
    }

    const country = find(this.countries, (item) => {
      return item.code === this.address.country_code;
    });
    this.states = country && country.states;
  }

  onStateChanged(key) {
    this.address.state = key;
  }

  displaySelectedState(state) {
    return state.name;
  }

  onSalutationChanged(key) {
    this.address.salutation = key;
  }

  submit() {
    this.save(this.address);
  }

  togglePrivacyModal() {
    this.showPrivacyModal = !this.showPrivacyModal;
  }
}
